import { type DrawerMenuItem } from '@cx-web/domain-types';
import classnames from 'classnames';

import { mergePersistentParams } from '../../../../utils/merge-persistent-params';
import WrappedIcon from '../../../WrappedIcon/index';

import styles from './SingleLink.module.css';

interface SingleLinkProps {
  callback?: (text: string) => void;
  hideIcons?: boolean;
  label?: string;
  page: DrawerMenuItem;
  pageDepth: number;
  serverUrl?: string;
}

const SingleLink = ({ hideIcons = false, page, pageDepth = 0, serverUrl }: SingleLinkProps) => {
  const { icon = '', link = '', name } = page;

  if (!name) {
    return null;
  }

  const requestUrl = serverUrl;

  // the link is internal when the url is oddschecker.com, occloud.io, localhost, or a subdomain of oddschecker.com, or is a relative path
  const isInternal =
    link?.includes('oddschecker.com') ||
    link?.includes('occloud.io') ||
    link?.includes('localhost') ||
    link?.startsWith('/') ||
    link?.startsWith('#');
  return (
    <div>
      <a
        className={classnames(styles.link, styles[`link${pageDepth}`])}
        data-testid="page-link"
        href={mergePersistentParams(link, requestUrl)}
        key={name}
        rel={isInternal ? undefined : 'nofollow'}
      >
        <WrappedIcon
          containerClassName={styles.iconContainer}
          hideIcon={hideIcons}
          iconClassName={styles.linkIcon}
          iconString={icon}
        />
        <div className={styles.linkText}>{name}</div>
      </a>
    </div>
  );
};

export default SingleLink;
